"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Block = function Block() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.73 6.94l-.14-.25a2.13 2.13 0 00-.73-.69l-4.72-2.73a2 2 0 00-1-.27h-.28a1.92 1.92 0 00-1 .27L4.14 8.32a2 2 0 00-.73.73l-.14.25a2 2 0 00-.27 1v5.76a2 2 0 00.27 1l.14.25c.18.3.43.55.73.73l4.72 2.69a2 2 0 001 .27h.28a1.92 1.92 0 001-.27l8.72-5.05c.303-.175.555-.427.73-.73l.14-.25a2 2 0 00.27-1V7.94a2 2 0 00-.27-1zM13.86 5h.28L18 7.2l-8 4.63-4-2.28L13.86 5zM11 18.5l7.86-4.5.14-.3V8.93l-8 4.64v4.93z",
    clipRule: "evenodd"
  });
};

exports.Block = Block;